import { useState, useEffect } from 'react';
import { GOOGLE_SHEETS, UI_TEXT } from '../utils/constants';

export const useGoogleSheets = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBooks();
  }, []);

  const fetchBooks = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(GOOGLE_SHEETS.API_URL);
      const text = await response.text();
      
      // Remove JSONP wrapper: google.visualization.Query.setResponse(...)
      const jsonData = text.substring(47).slice(0, -2);
      const data = JSON.parse(jsonData);
      
      const rows = data.table.rows;
      
      // Columns: [№, Прізвище, Ім'я, Назва книги, Рік видання, Рік публікації твору, ISBN-13, Жанр, Вік, Короткий опис, Новинка]
      const parsedBooks = rows.map((row, index) => {
        const surname = row.c[1]?.v || '';
        const firstName = row.c[2]?.v || '';
        const author = [firstName, surname].filter(Boolean).join(' ');
        return {
          id: row.c[0]?.v || `book-${index}`,
          title: row.c[3]?.v || '',
          author,
          pubYear: row.c[4]?.v || '',
          origYear: row.c[5]?.v || '',
          isbn: row.c[6]?.v || '',
          genre: row.c[7]?.v || '',
          ageCategory: row.c[8]?.v || '',
          description: row.c[9]?.v || '',
          isNew: row.c[10]?.v === true,
          status: UI_TEXT.available,
        };
      });

      setBooks(parsedBooks);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching books:', err);
      setError(UI_TEXT.error);
      setLoading(false);
    }
  };

  return { books, loading, error, refetch: fetchBooks };
};